import { Link } from '../../../Link/Link';
import { useMagazinePublishedDate } from '../../hooks/useMagazinePublishedDate';

type ArticleSidebarItemProps = {
  index: number;
  title: string;
  category?: string;
  publishedDate: string;
  href: string;
  'data-testid'?: string;
};

function ArticleSidebarItem({ index, title, category, publishedDate, href, 'data-testid': dataTestId }: ArticleSidebarItemProps) {
  const formattedDate = useMagazinePublishedDate(publishedDate);

  return (
    <Link
      href={href}
      simplified
      className="group flex w-full min-w-0 justify-start whitespace-normal px-2 py-6 font-normal no-underline transition-colors hover:bg-container"
      data-testid={dataTestId}
      data-track-name="Article Item"
      data-track-position={index}
      data-track-type={category}
      data-track-title={title}
    >
      <article className="flex min-w-0 flex-1 flex-col">
        <div className="flex min-w-0 items-center gap-4">
          <span
            className="flex size-6 shrink-0 items-center justify-center rounded-full bg-foreground text-center text-xs font-bold leading-3 text-background"
            aria-hidden="true"
            data-testid={`${dataTestId}-number`}
          >
            {index}
          </span>
          <div className="flex min-w-0 items-center gap-2 text-xs font-normal leading-[18px] text-foreground">
            {category && (
              <>
                <span className="truncate" data-testid={`${dataTestId}-category`}>
                  {category}
                </span>
                <span className="size-[3px] shrink-0 rounded-full bg-foreground" aria-hidden="true" />
              </>
            )}
            <time className="truncate" dateTime={publishedDate} data-testid={`${dataTestId}-date`}>
              {formattedDate}
            </time>
          </div>
        </div>
        <h3 className="paragraph-strong min-w-0 break-words pl-10 text-foreground group-hover:underline" data-testid={`${dataTestId}-title`}>
          {title}
        </h3>
      </article>
    </Link>
  );
}

export { ArticleSidebarItem, type ArticleSidebarItemProps };
